import { PileType } from 'src/games/phasersolitaire/logic/logic-types';
import { PileViewModel } from './pile-view-model';
import { GameServices } from '../../game-services';

export class WastePileViewModel extends PileViewModel {
  constructor(gameServices: GameServices) {
    super(gameServices, PileType.Waste);
  }
}
